import "global/underscore.js";

export function PixleeReviews() {
    this.visible = false;

    this.generateReview = function(product, reviewHolderParent) {
        if (!this.visible || _.isFalsy(product) || _.isFalsy(product.review)) {
            return;
        }

        let reviewHolder;

        if (!_.isFalsy(reviewHolderParent)) {
            reviewHolder = reviewHolderParent.find('.review_holder');
        } else {
            reviewHolder = $('.review_holder');
        }

        let templateData = _.clone(product);
        templateData.isReviewFeatured = this.visible;

        reviewHolder.empty();
        reviewHolder.append(require('./templates/reviews/_reviews.jst.ejs')(templateData));
    };

    this.setVisibility = function(visible) {
        this.visible = visible;
    };
}
